// extracted by mini-css-extract-plugin
export default {"ctnStatic":"PaginiStatice_ctnStatic__KW2k4"};